import React, { useState, useEffect } from "react";
import { Typography, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomDetailedList from "../../components/Custom/CustomDetailedList";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import { useNavigate } from "react-router-dom";

const VerificationTasks = () => {
  const [pendingTasks, setPendingTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPendingTasks = async () => {
      try {
        const response = await api.get(
          "/programs/vle-pending-verifications/",
          {}
        );
        setPendingTasks(response.data.data);
      } catch (error) {
        console.error("Error fetching pending tasks:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingTasks();
  }, []);

  const renderTaskData = (task, program) => [
    {
      label: t("Program Name"),
      value: task.program_name,
      type: "text",
    },
    {
      label: t("Farmer Name"),
      value: program.farmer_name,
      type: "text",
    },
    {
      label: t("Task Name"),
      value: task.task_name,
      type: "text",
    },
  ];

  const handleViewTaskDetails = (actionId) => {
    navigate(`/vle/verification-task-details/${actionId}`);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="md">
          {pendingTasks.length === 0 ? (
            <div
              style={{
                height: "85vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="subtitle1">
                {t("No verification tasks found.")}
              </Typography>
            </div>
          ) : (
            <>
              <CustomTitle>Verification Tasks</CustomTitle>
              <div
                style={{
                  overflowY: "auto",
                  height: "100%",
                  textAlign: "center",
                  maxHeight: "100%",
                }}
              >
                {pendingTasks.map((program) => (
                  <Box key={program.farmer_name} sx={{ mb: 2 }}>
                    {program.pending_tasks.map((task) => (
                      <Box
                        key={task.task_id}
                        sx={{ mt: 2 }}
                        onClick={() => handleViewTaskDetails(task.action_id)}
                      >
                        <CustomDetailedList
                          id={task.task_id}
                          data={renderTaskData(task, program)}
                          buttonList={[]}
                        />
                      </Box>
                    ))}
                  </Box>
                ))}
              </div>
            </>
          )}
        </Container>
      </LoaderContainer>
    </>
  );
};

export default VerificationTasks;
